<template>
  <div class="columns is-centered is-mobile">
    <div class="column is-narrow">
      <a
        href="https://play.google.com/store/apps/details?id=com.tinythoughts&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
        target="_blank"
      >
        <img alt="Get it on Google Play" style="height:60px;width:155px;" src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
      </a>
    </div>
    <div class="column is-narrow">
      <a href="https://apps.apple.com/us/app/tinythoughts/id1491419111?mt=8" target="_blank" style="margin:10px;display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2019-12-20&kind=iossoftware&bubble=ios_apps) no-repeat;width:135px;height:40px;"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownloadLinks',
};
</script>

<style scoped lang="scss">

</style>
